/**
 * Phonics Letter Yy — 课程数据配置
 * Story 1: 右上5单词 + 下部4句台词（英文+中文）
 * Story 2: 上视频下4句台词（英文，不要翻译）
 * Story 3: 左上视频，左下3句右边4句台词（英文，不要翻译）
 */

const MEDIA_BASE = '/media/phonics/yy';

export const letterDataYy = {
  letter: 'Yy',
  title: 'Phonics',
  subtitle: 'Letter Yy',

  mediaBase: MEDIA_BASE,

  // Step 1: 歌曲视频片段
  songVideo: {
    src: `${MEDIA_BASE}/Yy.mp4`,
    poster: `${MEDIA_BASE}/cover.png`,
    startTime: 11,
    endTime: 115,
  },

  // Step 2: 4 格单词视频
  wordVideos: [
    { id: 1, src: `${MEDIA_BASE}/video_s3_word1.mp4`, cover: `${MEDIA_BASE}/image8.png`,  word: 'yoyo',   wordCn: '悠悠球' },
    { id: 2, src: `${MEDIA_BASE}/video_s3_word2.mp4`, cover: `${MEDIA_BASE}/image9.png`,  word: 'yellow', wordCn: '黄色' },
    { id: 3, src: `${MEDIA_BASE}/video_s3_word3.mp4`, cover: `${MEDIA_BASE}/image10.png`, word: 'yarn',   wordCn: '毛线' },
    { id: 4, src: `${MEDIA_BASE}/video_s3_word4.mp4`, cover: `${MEDIA_BASE}/image11.png`, word: 'yogurt', wordCn: '酸奶' },
  ],

  // Story sections
  storySections: [

    // Learn the Story (1) — 左视频右上5单词下边4句台词
    {
      label: 'Learn the Story (1)',
      layout: 'video-left-vocab-right',
      splitAt: 5,
      videos: [{ src: `${MEDIA_BASE}/video_story_1.mp4`, poster: `${MEDIA_BASE}/image13.png` }],
      lines: [
        // 右侧单词（5个）
        { en: 'yawn',       cn: '打哈欠',    audioEn: `${MEDIA_BASE}/w_en_s1_yawn.mp3`,       audioCn: `${MEDIA_BASE}/w_cn_s1_yawn.mp3` },
        { en: 'should',     cn: '应该',      audioEn: `${MEDIA_BASE}/w_en_s1_should.mp3`,     audioCn: `${MEDIA_BASE}/w_cn_s1_should.mp3` },
        { en: 'play',       cn: '玩',        audioEn: `${MEDIA_BASE}/w_en_s1_play.mp3`,       audioCn: `${MEDIA_BASE}/w_cn_s1_play.mp3` },
        { en: 'with',        cn: '用...一起', audioEn: `${MEDIA_BASE}/w_en_s1_with.mp3`,      audioCn: `${MEDIA_BASE}/w_cn_s1_with.mp3` },
        { en: 'play with',  cn: '和...玩',   audioEn: `${MEDIA_BASE}/w_en_s1_play_with.mp3`, audioCn: `${MEDIA_BASE}/w_cn_s1_play_with.mp3` },
        // 视频下方台词（4句）
        { en: "Yawn! Yawn! I'm bored.",      cn: '打哈欠！打哈欠！我好无聊。',    audioEn: `${MEDIA_BASE}/story1_en_1.mp3`, audioCn: `${MEDIA_BASE}/story1_cn_1.mp3` },
        { en: 'What should I do?',           cn: '我该做什么呢？',                 audioEn: `${MEDIA_BASE}/story1_en_2.mp3`, audioCn: `${MEDIA_BASE}/story1_cn_2.mp3` },
        { en: 'I have some yo-yos.',         cn: '我有一些悠悠球。',               audioEn: `${MEDIA_BASE}/story1_en_3.mp3`, audioCn: `${MEDIA_BASE}/story1_cn_3.mp3` },
        { en: "Let's play with the yo-yos.", cn: '我们玩悠悠球吧。',               audioEn: `${MEDIA_BASE}/story1_en_4.mp3`, audioCn: `${MEDIA_BASE}/story1_cn_4.mp3` },
      ],
    },

    // Learn the Story (2) — 上视频下4句台词（英文，不要翻译）
    {
      label: 'Learn the Story (2)',
      layout: 'video-top-lines-bottom',
      videos: [{ src: `${MEDIA_BASE}/video_story_2.mp4`, poster: `${MEDIA_BASE}/image14.png` }],
      lines: [
        { en: "Yawn! Yawn! I'm bored.",      audioEn: `${MEDIA_BASE}/story2_en_1.mp3` },
        { en: 'What should I do?',            audioEn: `${MEDIA_BASE}/story2_en_2.mp3` },
        { en: 'I have some yarn.',            audioEn: `${MEDIA_BASE}/story2_en_3.mp3` },
        { en: "Let's play with the yarn.",   audioEn: `${MEDIA_BASE}/story2_en_4.mp3` },
      ],
    },

    // Learn the Story (3) — Letter Teams 排版：左上视频，左下3句右边4句台词（不要翻译）
    // story-video-left-lines-right: lines[0..splitAt-1]→左视频下方，lines[splitAt..]→右边
    {
      label: 'Learn the Story (3)',
      layout: 'story-video-left-lines-right',
      splitAt: 3,
      videos: [{ src: `${MEDIA_BASE}/video_story_3.mp4`, poster: `${MEDIA_BASE}/image15.png` }],
      lines: [
        // 左下方台词（3句）— 前 splitAt=3 句去左视频下方
        { en: "Yawn! Yawn!",               audioEn: `${MEDIA_BASE}/story3_en_1.mp3` },
        { en: "I'm bored.",                 audioEn: `${MEDIA_BASE}/story3_en_2.mp3` },
        { en: "What should I do?",          audioEn: `${MEDIA_BASE}/story3_en_3.mp3` },
        // 右侧台词（4句）— 后面的去右边
        { en: "I have some yogurt.",        audioEn: `${MEDIA_BASE}/story3_en_4.mp3` },
        { en: "Let's eat some yogurt.",     audioEn: `${MEDIA_BASE}/story3_en_5.mp3` },
        { en: "Yellow yogurt!",             audioEn: `${MEDIA_BASE}/story3_en_6.mp3` },
        { en: "I love the yellow yogurt.",  audioEn: `${MEDIA_BASE}/story3_en_7.mp3` },
      ],
    },

  ],

  coverBg: `${MEDIA_BASE}/image1.jpeg`,
  coverPoster: `${MEDIA_BASE}/cover.png`,
};

export default letterDataYy;
